import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=723dd8cd&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=723dd8cd&prod&lang=less"
import style1 from "./edit.vue?vue&type=style&index=1&id=723dd8cd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723dd8cd",
  null
  
)

export default component.exports